// extracted by mini-css-extract-plugin
export default {"bar":"MobileTabBar_bar__nRg7p","tab":"MobileTabBar_tab__QAutP","icon":"MobileTabBar_icon__393n2","label":"MobileTabBar_label__g1hpi","active":"MobileTabBar_active__g3tXF"};